








































import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'

import { isIslandHopping } from '@/globalMixin'

@Component({
  components: {
    [Button.name]: Button,
    Checkbox,
  },
})
export default class MakePaymentTermsStep extends Vue {
  @Prop() termsTemplate!: string
  @Prop({ default: false }) termsAccepted!: boolean

  get termsLink(): string {
    return isIslandHopping()
      ? 'https://www.island-hopping.com/booking-terms'
      : 'https://www.sail-croatia.com/booking-terms'
  }
}
